import { Component } from "react";
import "./mainUI.css";
import config from "../../config/app.config";
import { Button, Divider, Select, Spin, message } from "antd";
import {
  DollarOutlined,
  LeftOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import iconPay from "../../assets/images/icon/icon.png";
import generateReferenceIdCustomFormat from "../../helpers/generateReferenceIdSimple";
import { showToast, openNotification, calculateFee } from "../../utils";
import Apibank from "../../api/Apibank";
import PromptPayPaymentPage from "../../components/PromptPayPayment";
import { t } from "i18next";
import {  tagsTypeBageColor } from "../../helpers/tagsBage";

// Component สำหรับส่วนหัวของหน้า
const Header = () => (
  <div className="header2">
    <div className="logo-container">
      <img src={iconPay} alt="logo2" className="logo2" />
      <div className="logo-text">
        <p className="logo-title">{config.web_name}</p>
        <p className="logo-subtitle">✔ จ่ายเงินง่ายปลอดภัย 100%</p>
      </div>
    </div>
  </div>
);

// Component สำหรับส่วนตัวเลือกบัญชี
const AccountSection = ({ bankAccount, selectedAccount, onSelectAccount }) => {
  // กรองบัญชีที่ "Active" และจัดรูปแบบข้อมูลสำหรับ Select component
  const activeBankAccounts = bankAccount?.filter((item) => item);

  const options = activeBankAccounts?.map((item) => ({
    label: (
      <span className="fs-sm-12">
        <span
          style={{
            fontWeight: "600",
            color: tagsTypeBageColor(item.accountType),
          }}
        >{`[ ${t(item.accountType)} ]`}</span>{" "}
        -{" "}
        <span style={{ textTransform: "uppercase" }}>{item.bank.bank_id}</span>{" "}
        - {item.accountName} - {item.accountNumber}
      </span>
    ),
    value: item.id,
    disabled:  item.accountType === 'withdrawal' && item.status_bank  === 'Active'
  }));

  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-number">1</span>
        <span className="section-title">เลือกบัญชี</span>
      </div>
      <div className="account-info mb-2">
        <Select
          id="addCredit"
          className="addCredit"
          showSearch
          style={{ width: 370 }}
          placeholder="Select Bank Account"
          optionFilterProp="label"
          options={options}
          value={selectedAccount}
          onChange={onSelectAccount}
        />
      </div>
      {/* <small style={{ marginLeft: "10px" }}>* บัญชี ที่มีสถานะ 'Active'</small> */}
    </div>
  );
};

// Component สำหรับส่วนจำนวนการเติมเงิน
const DepositAmountSection = ({ amount, onSelectAmount }) => {
  const amounts = [10000, 20000, 30000, 40000, 50000];

  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-number">2</span>
        <span className="section-title">จำนวนการเติมเงิน</span>
      </div>
      <div className="tab-buttons">
        <form>
          <input
            type="text"
            name="search"
            className="customs"
            value={amount || ""}
            placeholder="กำหนดจำนวนเงิน"
            onChange={(e) => onSelectAmount(e.target.value)}
          />
        </form>
      </div>
      <div className="amount-grid">
        {amounts.map((amt) => (
          <div
            key={amt}
            className={`amount-item ${amt === amount ? "selected" : ""}`}
            onClick={() => onSelectAmount(parseFloat(amt))}
          >
            <span className="coin-icon">
              <DollarOutlined />
            </span>
            <span className="amount-value">{amt.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Component สำหรับส่วนตัวเลือกการชำระเงิน
const PaymentMethodSection = ({ paymentType, onSelectMethod }) => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-number">3</span>
        <span className="section-title">ตัวเลือกการชำระ</span>
      </div>
      <div className="payment-grid">
        <div
          key="QR"
          className={`payment-item ${paymentType === "QR" ? "selected" : ""}`}
          onClick={() => onSelectMethod("QR")}
        >
          <QrcodeOutlined style={{ fontSize: "22px" }} />
          <span style={{ marginLeft: "5px" }}>QR Code</span>
        </div>
      </div>
    </div>
  );
};
// Main Class Component ที่รวบรวมทุกอย่างเข้าด้วยกัน
class MainUI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccount: null,
      amount: null,
      referenceId: generateReferenceIdCustomFormat(),
      paymentType: "QR",
      loading: false,
      showFormQrcode: false,
      QRstring: null,
      qrExpireTime: null,
      qrStatus: "active",
      name: null,
      uuid: "",
      ReferenceId: null,
      accountNo: null,
    };
  }
  // ฟังก์ชันสำหรับจัดการเมื่อ QR Code หมดอายุ
  handleExpiredQr = () => {
    this.setState({ qrStatus: "expired", QRstring: null });
    showToast("error", "QR Code หมดอายุแล้ว");
  };

  handleSelectAmount = (amount) => {
    let amt = amount;
    this.setState({ amount: amt });
  };

  handleSelectMethod = (method) => {
    this.setState({ paymentType: method });
  };

  handleSelectAccount = (value) => {
    this.setState({ selectedAccount: value });
  };

  // เมธอดสำหรับสร้างรายการชำระเงิน
  handleCreatePayment = async () => {
    const { amount, paymentType, selectedAccount, referenceId } = this.state;
    const { merchantInfo } = this.props;

    // 1. ตรวจสอบข้อมูลที่จำเป็น
    if (!amount || !paymentType || !selectedAccount) {
      message.error(
        "กรุณาเลือกบัญชี จำนวนเงิน และช่องทางการชำระเงินให้ครบถ้วน"
      );
      return;
    }
    let merchantId = merchantInfo?.id;
    if (!merchantId) {
      message.error("ไม่พบข้อมูลร้านค้า");
      return;
    }
    this.setState({ loading: true });

    // 2. สร้าง Payload สำหรับ API
    const paymentPayload = {
      bankAccount_id: selectedAccount,
      merchantId: merchantId,
      referenceId: referenceId,
      amount: parseFloat(amount),
      paymentType: paymentType,
      customerUuid: selectedAccount,
      remark: "",
      
      note: "",
    };

    // 3. กำหนด endpoint ของ API
    try {
      const res = await Apibank.getPayment(paymentPayload);
      // 4. ตรวจสอบการตอบกลับ
      if (res?.data?.success) {
        message.success("กรุณาสแกน QRcode เพื่อชำระเงิน");
        const newQRString = res.data.data.qrCode;
        const newExpireISOString = res.data.data.qrExpireTime;
        const newCustomerName = res.data.data.full_data.customerName;
        const newReferenceId = res.data.data.full_data.referenceId;
        const newCustomerAccountNo = res.data.data.full_data.customerAccountNo;
        const uuid = res.data.data.full_data.uuid

        this.setState({
          loading: false,
          showFormQrcode: true,
          QRstring: newQRString,
          qrExpireTime: newExpireISOString,
          name: newCustomerName,
          ReferenceId: newReferenceId,
          accountNo: newCustomerAccountNo,
          uuid: uuid,
          qrStatus: "active",
        });
      } else {
        openNotification(
          "error",
          "Error",
          res.data?.message || "!เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์"
        );
        this.setState({
          loading: false,
          qrStatus: "expired",
          showFormQrcode: false,
          QRstring: null,
        });
      }
    } catch (err) {
      openNotification(
        "error",
        `error :${err.status}`,
        t(err?.response?.data?.message) ||
          err.message ||
          "!เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์"
      );

      console.error("Payment error:", err);
      // ในกรณีที่ API error, ควรแสดงหน้า QR code แต่มีสถานะหมดอายุ
      this.setState({
        loading: false,
        qrStatus: "expired",
        showFormQrcode: false,
        QRstring: null,
      });
    }
  };
  // ฟังก์ชันสำหรับกลับไปหน้าฟอร์ม
  handleOnBack = () => {
    // ล้างค่า state ทั้งหมดที่เกี่ยวข้องกับ QR code และกลับไปหน้าฟอร์มหลัก
    this.setState({
      showFormQrcode: false,
      QRstring: null,
      qrExpireTime: null,
      qrStatus: "active",
      name: null,
      ReferenceId: null,
      uuid: null,
      accountNo: null,
      referenceId: generateReferenceIdCustomFormat(), // สร้าง referenceId ใหม่
    });
  };

  render() {
    const { amount, paymentType, selectedAccount, showFormQrcode, loading } =
      this.state;
    const { allBankAccountData, payinFee } = this.props; 
    const isPaymentButtonDisabled = !amount || !paymentType || !selectedAccount;
    return (
      <Spin spinning={loading} tip="กำลังสร้างรายการเติมเงิน...">
        <div className="deposit-page">
          {showFormQrcode ? (
            <>
              <Divider orientation="left">
                <Button
                  shape="circle"
                  onClick={this.handleOnBack}
                  icon={<LeftOutlined />}
                />{" "}
                ย้อนกลับ
              </Divider>

              {/* Main Qr code */}
              <PromptPayPaymentPage
                qrString={this.state.QRstring}
                amount={amount}
                name={this.state.name}
                referenceId={this.state.ReferenceId}
                accountNo={this.state.accountNo}
                qrExpireTime={this.state.qrExpireTime}
                qrStatus={this.state.qrStatus}
                handleOnBack={this.handleOnBack} // ส่ง handleOnBack ไปยัง component ลูก
                uuid={this.state.uuid}
              />
            </>
          ) : (
            <>
              <Header />
              <div className="main-content">
                <AccountSection
                  bankAccount={allBankAccountData}
                  selectedAccount={selectedAccount}
                  onSelectAccount={this.handleSelectAccount}
                />
                <DepositAmountSection
                  amount={amount}
                  onSelectAmount={this.handleSelectAmount}
                />
                <PaymentMethodSection
                  paymentType={paymentType}
                  onSelectMethod={this.handleSelectMethod}
                />
                <br />
                {!isPaymentButtonDisabled && (
                  <>
                  {/* ค่าธรรมเนียมฝาก  d-none */}
                    <div
                      className="mb-3  d-none"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "5",
                      }}
                    >
                      <span style={{ fontWeight: "600", marginRight: "5px" }}>
                        ค่าธรรมเนียมฝาก:{" "}
                      </span>
                      <b>
                        <DollarOutlined style={{ color: "#5cb85c" }} />{" "}
                        {calculateFee(amount, parseFloat(payinFee))}(
                        {parseFloat(payinFee)}).-
                      </b>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "5",
                      }}
                    >
                      <span style={{ fontWeight: "600", marginRight: "5px" }}>
                        จำนวนเงิน:{" "}
                      </span>
                      <b>
                        <DollarOutlined style={{ color: "#5cb85c" }} />{" "}
                        {Intl.NumberFormat().format(amount)}.-
                      </b>
                    </div>
                  </>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="primary"
                    className="payment-submit-button"
                    onClick={this.handleCreatePayment}
                    disabled={isPaymentButtonDisabled}
                  >
                    สร้างรายการเติมเงิน
                  </Button>
                </div>
                <br />
              </div>
            </>
          )}
        </div>
      </Spin>
    );
  }
}

export default MainUI;
